<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Would you like to create <strong>{{data.name}}__</strong>?</p>
    <button type="button" @click="create" class="btn btn-fill btn-info">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        createCompany: false
      }
    },
    methods: {
      create() {
        this.$store.commit('companies/resetEdit')
        this.$store.set('companies/edit@name', this.data.name)
        this.$store.set('companies/edit@types', [this.data.type])
        this.$store.set('companies/edit@active', true)
        this.createCompany = true
        this.$eventHub.$emit('show-modal-4', 'Company', null, '1000px')
      },
      closeModal() {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.createCompany) {
        this.$eventHub.$emit('noCompanySelected', this.data.type)
      }
    }
  }
</script>
